import { createSelector } from "reselect";

export const getActiveLoadProcess = (state) =>
  state.loader.activeLoadingProcess;

export const isActiveLoadProcess = createSelector(
  getActiveLoadProcess,
  (process) => !!process.length
);
